import apiClient from './apiService';

class AttendanceReportService {
    constructor() {
        if (AttendanceReportService.instance) return AttendanceReportService.instance;
        AttendanceReportService.instance = this;
    }

    async getBySection(params = {}) {
        try {
            const response = await apiClient.get('/attendance-report/by-section', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    async getByDistrict(params = {}) {
        try {
            const response = await apiClient.get('/attendance-report/by-district', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    async getByUser(params = {}) {
        try {
            const response = await apiClient.get('/attendance-report/by-user', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    async getByEntity() {
        try {
            const response = await apiClient.get('/attendance-report/by-entity');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static getInstance() {
        if (!AttendanceReportService.instance) {
            AttendanceReportService.instance = new AttendanceReportService();
        }
        return AttendanceReportService.instance;
    }
}

export default AttendanceReportService.getInstance();
